import { LONG_RUNNING_FALLBACK_RETRY_SECONDS } from '../../../constants';

// Parses the Retry-After header (delta-seconds or HTTP-date) into a seconds
// value, used verbatim as the backend asked. The only sanity floor is 0 (a
// negative delay makes no sense); a default is used when missing or invalid.
export const parseRetryAfterSeconds = (
  retryAfter: string | undefined
): number => {
  const nonNegative = (seconds: number): number => Math.max(seconds, 0);

  if (retryAfter === undefined || retryAfter.trim() === '') {
    return LONG_RUNNING_FALLBACK_RETRY_SECONDS;
  }

  const asNumber = Number(retryAfter);
  if (Number.isFinite(asNumber)) {
    return nonNegative(asNumber);
  }

  const asDate = Date.parse(retryAfter);
  if (!Number.isNaN(asDate)) {
    return nonNegative(Math.ceil((asDate - Date.now()) / 1000));
  }

  return LONG_RUNNING_FALLBACK_RETRY_SECONDS;
};
